import { useEffect, useState, useCallback } from "react";
import client from "@/lib/api";

/**
 * Fetch live rankings from our backend proxy of territoria.world.
 * Returns { entries, updatedAt, cached, stale, loading, error, refresh, count }.
 * Skips fetch when `enabled` is false so we don't hit the API for mock tabs.
 */
export default function useLiveRankings({ category, metric, limit = 25, enabled = true }) {
  const [state, setState] = useState({
    entries: [],
    updatedAt: null,
    cached: false,
    stale: false,
    loading: enabled,
    error: null,
    count: 0,
  });

  const fetchNow = useCallback(async (force = false) => {
    if (!enabled || !category || !metric) return;
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const r = await client.get(`/game-rankings/${category}`, {
        params: { metric, limit, ...(force ? { refresh: true } : {}) },
      });
      setState({
        entries:   r.data.entries || [],
        updatedAt: r.data.updated_at || null,
        cached:    !!r.data.cached,
        stale:     !!r.data.stale,
        count:     r.data.count || (r.data.entries?.length ?? 0),
        loading:   false,
        error:     null,
      });
    } catch (e) {
      setState((s) => ({
        ...s,
        loading: false,
        error: e?.response?.data?.detail?.error || e?.response?.data?.detail || e.message || "Failed to load rankings",
      }));
    }
  }, [category, metric, limit, enabled]);

  useEffect(() => { fetchNow(false); }, [fetchNow]);

  return { ...state, refresh: () => fetchNow(true) };
}
